var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 119,
    viewBox: "0 0 116 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M11.8125 40.25H0V28.4375L63 -7L126 28.4375V40.25H114.188H11.8125ZM101.883 28.4375L63 6.78125L23.8711 28.4375H56.1094C55.3711 27.4531 55.125 25.9766 55.125 24.5C55.125 20.3164 58.5703 16.625 63 16.625C67.1836 16.625 70.875 20.3164 70.875 24.5C70.875 25.9766 70.3828 27.4531 69.6445 28.4375H101.883ZM15.75 48.125H27.5625V87.5H43.3125V48.125H55.125V87.5H70.875V48.125H82.6875V87.5H98.4375V48.125H110.25V87.5H112.219H118.125V99.3125H112.219H13.7812H7.875V87.5H13.7812H15.75V48.125ZM5.90625 107.188H120.094H126V119H120.094H5.90625H0V107.188H5.90625Z",
    fill: "#404674"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank-icon.69cf5f8a0bea1add4a0c94b55414e700.svg";
export { ForwardRef as ReactComponent };